import { noNulls, pluckValue } from '../filters.component';

export const FILTER_TYPES = {
  text: 'text',
  date: 'date',
  datetime: 'datetime',
  integer: 'integer',
  decimal: 'decimal',
};

const validatorTypeMap = {
  Decimal: 'decimal',
  Integer: 'integer',
  Text: 'empty',
};

const validatorMap = {
  decimal: /^-?(0|[1-9]\d*)(\.\d+)?$/,
  integer: /^-?(0|[1-9]\d*)$/,
  empty: /^\S+\s*\S*$/,
};

const getValidator = (dataType) => validatorMap[validatorTypeMap[dataType] || 'empty'];

/* @abstract */
export class AttributeFilter {
  constructor(rawAttr) {
    const { id, key } = rawAttr;
    this.rawAttr = rawAttr;
    this.id = id;
    this.key = key;
    this.label = key;
    this.applied = false;
    this.anyValue = false;
    this.selectedValues = [];
    this.selectedRange = {};
    this.freeform = rawAttr.freeform;
    this.range = rawAttr.range;
    this.validator = getValidator(rawAttr.dataType);
  }
}

export class FreeformAttributeFilter extends AttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.text;
  }
}

export class DateAttributeFilter extends FreeformAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.date;
  }
}

export class DatetimeAttributeFilter extends DateAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.datetime;
  }
}

export class IntegerAttributeFilter extends FreeformAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.integer;
  }
}

export class DecimalAttributeFilter extends IntegerAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.decimal;
  }
}

export class ListAttributeFilter extends FreeformAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);

    this.validValues = this.values = rawAttr.values.filter(noNulls).map(pluckValue);
    this.selectedValues = [];
  }
}

/* @abstract */
export class RangeAttributeFilter extends FreeformAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.freeform = false;
  }
}

export class DateRangeAttributeFilter extends RangeAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.date;
  }
}

export class IntegerRangeAttributeFilter extends RangeAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.integer;
  }
}

export class DecimalRangeAttributeFilter extends IntegerRangeAttributeFilter {
  constructor(rawAttr) {
    super(rawAttr);
    this.TYPE = FILTER_TYPES.decimal;
  }
}

export const mapFilter = (item) => {
  const { dataType, freeform, values } = item;

  if (dataType === 'Date' || dataType === 'Datetime') {
    return freeform ? new DateAttributeFilter(item) : new DateRangeAttributeFilter(item);
  }

  if (dataType === 'Integer') {
    return freeform ? new IntegerAttributeFilter(item) : new IntegerRangeAttributeFilter(item);
  }

  if (dataType === 'Decimal') {
    return freeform ? new DecimalAttributeFilter(item) : new DecimalRangeAttributeFilter(item);
  }

  if (values && values.length > 0) {
    return new ListAttributeFilter(item);
  }

  return new FreeformAttributeFilter(item);
};
